import React, {useEffect, useState} from 'react';

import classes from './ExamScheduleGrid.module.scss';

import AnnouncementGridItem from '../Announcement/AnnouncementGridItem/AnnouncementGridItem';
import {getMonthNameByNumber, getNextLessonToEnd, getShortDayName} from '../../../services/scheduleService';
import ScheduleGridItem from '../ScheduleGrid/ScheduleGridItem/ScheduleGridItem';
import {getDateFromString, getTodayStart, isToday, stringToDateTime} from '../../../services/generalService';
import {Collapse} from 'antd';
import {cloneDeep} from "lodash";

const { Panel } = Collapse;

const ExamScheduleGrid = ({ schedule, scheduleType, scheduleItemType, ifMobileGrid, rawExams }) => {

    const tableToBeDisplayed = window.innerWidth > 700;
    const [months, setMonths] = useState(createMonthsArrayBasedOnSchedule(schedule))
    const [rerenderTimeoutId, setRerenderTimeoutId] = useState(null)
    const [days] = useState(['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']);

    const [prevSchedule, setPrevSchedule] = useState(schedule);

    function createMonthsArrayBasedOnSchedule(schedule) {
        if (!schedule) return [];
        return schedule.map((monthItem, monthIndex) => {
            return {id: monthIndex, status: !!pastMonth(monthItem.period)}
        });
    }

    function pastMonth(date) {
        const month = new Date().getMonth() + 1;
        const year = new Date().getFullYear();
        return (parseInt(date.substr(0, 2)) < month && Number(date.substr(3)) === year) || date.substr(3) < year;
    }

    useEffect(() => {
        let timeoutId = null;
        const currentDate = new Date();
        const todayLessons = rawExams.filter(exam => isToday(exam.dateLesson));
        if (todayLessons) {
            const currentTime = currentDate.getTime();
            const nextLessonToEnd = getNextLessonToEnd(todayLessons, currentTime);
            if (nextLessonToEnd) {
                const nextEndLessonTime = stringToDateTime(nextLessonToEnd.endLessonTime).getTime();
                const nextRerenderTime = nextEndLessonTime + 60 * 1000;//1 минута
                timeoutId = setTimeout(() => {
                    setRerenderTimeoutId(timeoutId);
                }, nextRerenderTime - currentTime);
            }
        }
        return () => clearTimeout(timeoutId);
    }, [rerenderTimeoutId, rawExams])

    useEffect(() => {
        if (!tableToBeDisplayed) {
            setTimeout(() => scrollToNearestExamDate(), 5);
        }
    }, []);

    const updateMonths = (months, updatedMonth) => {
        const monthsUpdated = months.map(m => {
            let monthCopy;
            if (updatedMonth.id === m.id) {
                updatedMonth.status = !updatedMonth.status;
                monthCopy = cloneDeep(updatedMonth);
            } else {
                monthCopy = cloneDeep(m);
            }
            return monthCopy;
        })
        setMonths(monthsUpdated);
    }

    const scrollToNearestExamDate = () => {
        let elemToScrollTo = null;
        const date = getTodayStart();
        const elements = document.getElementsByClassName(classes.dateContainer);
        if (document.getElementById(date)) {
            elemToScrollTo = document.getElementById(date);
        } else if (elements.length !== 0) {
            let nearestDate = elements[elements.length - 1];
            for (const elem of elements) {
                if (Math.abs(elem.id - date) < Math.abs(nearestDate.id - date) && (elem.id - date) > 0) {
                    nearestDate = elem;
                }
            }
            elemToScrollTo = nearestDate;
        }
        if (elemToScrollTo) {
            const yOffset = -80;
            const y = elemToScrollTo.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }

    const getPanelHeader = (monthItem) => {
        return (<span style={{fontWeight: 700}}>
            {`${getMonthNameByNumber(parseInt(monthItem.period.substr(0, 2)), 10)} ${monthItem.period.substr(3)}`}
        </span>);
    }

    if (schedule !== prevSchedule) {
        setPrevSchedule(schedule);
        setMonths(createMonthsArrayBasedOnSchedule(schedule));
        return null;
    }

    return (
        <div className={classes.container}>
            {schedule.map((monthItem, monthIndex) => <React.Fragment key={monthIndex}>
                        <Collapse expandIconPosition="right" defaultActiveKey={!pastMonth(monthItem.period) ? monthItem.period : undefined} className={classes.monthNameContainer}
                                  onChange={() => updateMonths(months,months.at(monthIndex))}>

                            <Panel
                                header={getPanelHeader(monthItem)}
                                style={{width: "100%"}} key={monthItem.period} className="customCollapse" extra={
                                <span>{months.length !== 0 && months.at(monthIndex).status ? 'Развернуть' : 'Свернуть'}</span>}>
                                <div className={classes.monthExamsContainer}>
                                    {monthItem.exams.map(([date, exams], dayIndex) =>
                                        <div key={dayIndex}
                                             className={!isToday(date) ? classes.dayExamsContainer : classes.currentDayExamsContainer}>
                                            <div
                                                className={!isToday(date) ? classes.dateContainer : classes.dateContainerColored}
                                                id={getDateFromString(date)}>
                                                {`${date.substr(0, 2)}, ${getShortDayName(new Intl.DateTimeFormat('ru-RU', {weekday: 'long'}).format(new Date(date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1'))))}`}
                                            </div>

                                            <div>
                                                {exams.map((item, index) => {
                                                    const currentTime = new Date().getTime();
                                                    const nextLessonToEnd = getNextLessonToEnd(exams, currentTime);
                                                    const lessonPeriodIsCurrent = item.endLessonTime === nextLessonToEnd?.endLessonTime;
                                                    const dayName = days[new Date(getDateFromString(item.dateLesson)).getDay()];
                                                    return !item.announcement
                                                        ? <div style={{marginBottom: '10px'}}>
                                                            <ScheduleGridItem
                                                                key={index}
                                                                lesson={item}
                                                                scheduleItemType={scheduleItemType}
                                                                scheduleType={scheduleType}
                                                                ifMobileGrid={ifMobileGrid}
                                                                lessonPeriodIsCurrent={lessonPeriodIsCurrent}
                                                                dayName={dayName}
                                                            />
                                                        </div>
                                                        : <AnnouncementGridItem
                                                            key={index}
                                                            scheduleType={scheduleType}
                                                            note={item.note}
                                                            date={item.startLessonDate}
                                                            startLessonTime={item.startLessonTime}
                                                            endLessonTime={item.endLessonTime}
                                                            employees={item.employees}
                                                            studentGroups={item.studentGroups}
                                                            auditory={item.auditories}
                                                        />
                                                })}
                                            </div>
                                        </div>)}
                                </div>
                            </Panel>
                        </Collapse>
                </React.Fragment>
            )}
        </div>
    )
}

export default ExamScheduleGrid;